






import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import JobEmploymentPositionHelperComponents4JobEmploymentPositionResourceItem from './job-employment-position-helper-components-4-job-employment-position-resource-item.vue'

@Component({
  components: {
    JobEmploymentPositionHelperComponents4JobEmploymentPositionResourceItem
  }
})
class ProductResourceHelperComponents3ResourceList extends Vue {
  @Prop({ default: '' }) productResourceId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean
}

export default ProductResourceHelperComponents3ResourceList

